<template>
    <div class="orderdetail">
        <ul class="orderdetail-ul">
            <li class="orderdetail-li" :class="curClick == 0 ? 'li-active' : ''" @click="tabStype(0)">全部订单</li>
            <li class="orderdetail-li" :class="curClick == 1 ? 'li-active' : ''" @click="tabStype(1)">待付款</li>
            <li class="orderdetail-li" :class="curClick == 2 ? 'li-active' : ''" @click="tabStype(2)">待出行</li>
            <li class="orderdetail-li" :class="curClick == 3 ? 'li-active' : ''" @click="tabStype(3)">出行中</li>
            <li class="orderdetail-li" :class="curClick == 4 ? 'li-active' : ''" @click="tabStype(4)">已完成</li>
            <li class="orderdetail-li" :class="curClick == 5 ? 'li-active' : ''" @click="tabStype(5)">退款/售后</li>
        </ul>

        <div class="new-order-list" v-if="orderList.length">
            <div class="new-order-list-area"
                 v-for="(item,index) in orderList.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                 :key="index"
                 @click="toOrderDetail(item.id)"
            >

                <div class="order-list-single-number">
                    <div class="order-number">
                        订单号：888888888888
                    </div>
                    <div class="order-time">
                        下单时间： 2021-06-20 17:44:20
                    </div>
                </div>

                <div class="order-list-single">
                    <img class="order-area-img" :src="item.imgUrl" alt="">
                    <div class="order-area-box">
                        <div class="order-area-top">
                            <p class="order-area-type">{{ item.type }}</p>
                            <div class="order-area-money">
                                <span class="order-area-money-num">¥ {{ item.money }}</span>
                                |
                                <span class="order-area-status">{{ item.status }}</span>
                            </div>
                        </div>

                        <div class="order-trip">
                            <span class="order-trip-start">{{ item.start }}</span>
                            <img src="@/assets/images/persondata/personal_icon_dao.png" alt="">
                            <span class="order-trip-start">{{ item.end }}</span>
                        </div>

                        <div class="order-trip-time">
                            <span class="order-trip-start-time">
                                出发日期：
                            </span>
                            <span class="order-trip-detail-time">
                                {{ item.time }}
                            </span>
                        </div>

                        <div class="order-trip-car">
                            <span class="order-trip-start-time">
                                车辆数目：
                            </span>
                            <span class="order-trip-detail-time">
                                {{ item.carNum }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!--<el-pagination
                    class="el-pagination-car"
                    @size-change="handleSizeChange"
                    @current-change="currentPageChange"
                    :current-page.sync="currentPage"
                    layout="prev, pager, next, jumper"
                    :page-size="pagesize"
                    :pager-count="5"
                    :total="orderList.length"
            >
            </el-pagination>-->
        </div>

        <p class="no-more-order" v-else="orderList.length">
            没有更多订单
        </p>
    </div>
</template>

<script>
    export default {
        name: "orderdetail",
        data() {
            return {
                curClick: 0,
                orderList:[],
                // orderList: [
                //     {
                //         imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                //         type: '市内用车',
                //         money: '85255',
                //         status: '已完成',
                //         start: '出发城市出',
                //         end: '出发城市出发城市出发城市',
                //         time: '6月4号  9:00',
                //         carNum: '9',
                //         id: '01'
                //     },
                //     {
                //         imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                //         type: '市内用车',
                //         money: '85255',
                //         status: '已完成',
                //         start: '1222',
                //         end: '1222',
                //         time: '6月4号  9:00',
                //         carNum: '9',
                //         id: '02'
                //     },
                //     {
                //         imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                //         type: '市内用车',
                //         money: '85255',
                //         status: '已完成',
                //         start: '出发城市出',
                //         end: '出发城市出发城市出发城市',
                //         time: '6月4号  9:00',
                //         carNum: '9',
                //         id: '03'
                //     },
                //     {
                //         imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                //         type: '市内用车',
                //         money: '85255',
                //         status: '已完成',
                //         start: '1222',
                //         end: '1222',
                //         time: '6月4号  9:00',
                //         carNum: '9',
                //         id: '04'
                //     },
                //     {
                //         imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                //         type: '市内用车',
                //         money: '85255',
                //         status: '已完成',
                //         start: '出发城市出',
                //         end: '出发城市出发城市出发城市',
                //         time: '6月4号  9:00',
                //         carNum: '9',
                //         id: '05'
                //     },
                //     {
                //         imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                //         type: '市内用车',
                //         money: '85255',
                //         status: '已完成',
                //         start: '1222',
                //         end: '1222',
                //         time: '6月4号  9:00',
                //         carNum: '9',
                //         id: '06'
                //     },
                //     {
                //         imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                //         type: '市内用车',
                //         money: '85255',
                //         status: '已完成',
                //         start: '出发城市出',
                //         end: '出发城市出发城市出发城市',
                //         time: '6月4号  9:00',
                //         carNum: '9',
                //         id: '07'
                //     },
                //     {
                //         imgUrl: require('@/assets/images/persondata/personal_icon_shouji.png'),
                //         type: '市内用车',
                //         money: '85255',
                //         status: '已完成',
                //         start: '1222',
                //         end: '1222',
                //         time: '6月4号  9:00',
                //         carNum: '9',
                //         id: '081'
                //     },
                // ],

                currentPage: 1,
                pagesize: 6,
            }
        },
        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            currentPageChange(val) {
                console.log(`当前页: ${val}`);
            },
            tabStype(idx){
                this.curClick = idx;
            },
            toOrderDetail(id){
                this.$router.push({name: 'Orderparticulars',params: {orderId: id}});
            }
        }
    }
</script>

<style scoped>
    .orderdetail {
        width: 997px;
    }

    .orderdetail-ul {
        width: 997px;
        height: 56px;
        border-bottom: 1px solid #eee;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .orderdetail-li {
        min-width: 90px;
        height: 56px;
        line-height: 56px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333;
        text-align: center;
        cursor: pointer;
    }

    .li-active {
        position: relative;
        color: #FF5227;
    }

    .li-active:after {
        content: '';
        width: 46px;
        height: 2px;
        background: #FF5227;
        position: absolute;
        left: 50%;
        bottom: 0;
        margin-left: -23px;
    }

    .new-order-list {
        margin-top: 20px;
    }

    .new-order-list-area {
        width: 995px;
        height: 180px;
        border: 1px solid #EEEEEE;
        margin-bottom: 10px;
        cursor: pointer;
    }

    .order-list-single-number {
        width: 100%;
        height: 34px;
        background: #F8F8F8;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .order-number, .order-time {
        height: 34px;
        line-height: 34px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 24px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }

    .order-list-single {
        height: 147px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .order-area-img {
        width: 150px;
        height: 112px;
        border-radius: 4px;
        margin-left: 20px;
        margin-right: 20px;
    }

    .order-area-box {
        width: 770px;
        height: 112px;
    }

    .order-area-top {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-top: 5px;
    }

    .order-area-type {
        height: 24px;
        line-height: 24px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }

    .order-area-money {
        height: 24px;
        line-height: 24px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .order-area-money-num {
        color: #CF0000;
        font-size: 14px;
        height: 24px;
        line-height: 24px;
        margin-right: 6px;
    }

    .order-area-status {
        color: #2577E3;
        font-size: 14px;
        height: 24px;
        line-height: 24px;
        margin-left: 6px;
    }

    .order-trip {
        margin-top: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .order-trip-start {
        max-width: 240px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .order-trip img {
        width: 27px;
        height: 6px;
        margin-left: 18px;
        margin-right: 18px;
    }

    .order-trip-time, .order-trip-car {
        height: 24px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .order-trip-start-time {
        width: 70px;
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }

    .order-trip-detail-time {
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
    }

    .el-pagination-car {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 30px 0 48px 0;
    }

    .no-more-order {
        width: 100%;
        height: 20px;
        line-height: 24px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        text-align: center;
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/persondata/children/orderdetail.vue